import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import { BALANCE_RECORD_TYPE_MAP, WITHDRAW_TYPE_MAP } from "src/config/constants";
import Confirm from "src/components/common/ConfirmDialog";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "nickname", label: "用户", alignRight: false },
  { id: "method", label: "提现方式", alignRight: false },
  { id: "uid", label: "收款账号", alignRight: false },
  { id: "amount", label: "提现金额", alignRight: false },
  { id: "fee", label: "费率", alignRight: false },
  { id: "actual", label: "实际转出", alignRight: false },
  { id: "status", label: "状态", alignRight: false },
  // { id: "remark", label: "备注", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  { title: "通过", icon: iconEdit2 },
  { title: "拒绝", icon: iconEdit2 },
];

export default function WithdrawRecord() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [targetItem, setTargetItem] = useState(null);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/withdraw/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "通过") {
      handleReview(row, 1);
    } else if (type === "拒绝") {
      handleReview(row, 2);
    }
  };

  function handleReview(row, status) {
    Confirm({
      message: `确定${status == 1 ? "通过" : "拒绝"}${row.user.nickname} 金额${row.amount}元的转账申请吗？`,
      async onConfirm() {
        const { data } = await asyncRequest({
          path: "/finance/withdraw/auth",
          data: { id: row.id, status },
        });

        const item = items.find((it) => it.id === row.id);
        item.status = status;
        setItems([...items]);

        alert("操作成功", "success");
      },
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="提现申请">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            提现申请
          </Typography>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, user, realname, amount, fee, actual, createdAt, status, mobile, method, remark, account, bank } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left">{id}</TableCell>
                        <TableCell component="th" scope="row">
                          <UserInfo {...user} />
                        </TableCell>
                        <TableCell align="left">{WITHDRAW_TYPE_MAP[method]}</TableCell>
                        <TableCell align="left">
                          {method === 1 ? (
                            <Stack>
                              <Typography variant="subtitle2" noWrap>
                                账号:{mobile}
                              </Typography>
                              <Typography variant="subtitle2" noWrap>
                                真实姓名:{realname}
                              </Typography>
                            </Stack>
                          ) : (
                            <Stack>
                              <Typography variant="subtitle2" noWrap>
                                开户行:{bank}
                              </Typography>
                              <Typography variant="subtitle2" noWrap>
                                账号:{account}
                              </Typography>
                              <Typography variant="subtitle2" noWrap>
                                预留号码:{mobile}
                              </Typography>
                              <Typography variant="subtitle2" noWrap>
                                真实姓名:{realname}
                              </Typography>
                            </Stack>
                          )}
                        </TableCell>
                        <TableCell align="left">{StringUtil.toFixed2(amount)}</TableCell>
                        <TableCell align="left">{fee * 100}%</TableCell>
                        <TableCell align="left">{StringUtil.toFixed2(actual)}</TableCell>
                        {/* <TableCell align="left">{remark}</TableCell> */}
                        <TableCell>
                          <Label variant="ghost" color={["warning", "success", "error", "warning"][status]}>
                            {["待审核", "已发放", "已拒绝"][status]}
                          </Label>
                        </TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={status == 0 ? moreMenus : []} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
